import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'libelleTypePdp'
})

export class LibelleTypePdpPipe implements PipeTransform {

	transform(typePdp: number): string {
	    if (typePdp === 0) {
			return 'Général';
		} else if (typePdp === 1) {
			return 'Spécifique';
		}
 		return '';
   }
   
}